import { ContractorLoader } from './ContractorLoader';

export const contractorLoader: { (token?: string): ContractorLoader } = (token) =>
  new ContractorLoader(token);
